import {
    createAction,
    createSlice
} from '@reduxjs/toolkit';
import { CoreMsgTypes, FirmSecondaryApiTypeRecord } from '@tassat/fred-definitions';

export type FirmApiTypeState = {
    [firmId: string]: {
        [firmApiTypeId: string]: FirmSecondaryApiTypeRecord;
    };
};

const initialState: FirmApiTypeState = {};

const initialLoadAction = createAction<{ firmSecondaryApiTypeRecords: {
    [firmApiTypeId: string]: FirmSecondaryApiTypeRecord;
}; }>('InitialLoad');
const firmApiTypeRecordAction = createAction<FirmSecondaryApiTypeRecord>(CoreMsgTypes.FirmSecondaryApiTypeRecord);

const firmApiTypeSlice = createSlice({
    name: 'firmApiTypes',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                initialLoadAction,
                (
                    state,
                    action
                ) => {
                    if (action.payload.firmSecondaryApiTypeRecords) {
                        Object.values(action.payload.firmSecondaryApiTypeRecords)
                            .forEach((firmApiTypeRecord) => {
                                state[firmApiTypeRecord.FirmId] = { [firmApiTypeRecord.FirmSecondaryApiTypeId]: firmApiTypeRecord };
                            });
                    }
                }
            )
            .addCase(firmApiTypeRecordAction, (state, action) => {
                state[action.payload.FirmId] = { [action.payload.FirmSecondaryApiTypeId]: action.payload };
            });
    }
});

export default firmApiTypeSlice.reducer;